import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import Button from '../Button/Button'

import './NoProjects.scss'

export const NoProjects = ({ display, locale, t }) => {
  return (
    <div className={`c-no-projects display-${display}`}>
      {t('no-projects.message.text')}
      <Button to={`/${locale}/projects`} text={t('no-projects.button.text')} />
    </div>
  )
}

NoProjects.propTypes = {
  display: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default translate('translations')(NoProjects)
